'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-filters
 * @restrict E
 *
 * @description
 * #directive
 * Display the list of available characteristics to filter the channels, and a text seach box
 *
 * @template:'<div class="filter-options row" ng-if="$ctrl.showFilter" ng-class="{\'collapsed\': !$ctrl.isFiltersVisible}"><div class="search-box"><label for="channelSearch" data-translate="FILTERS.SEARCH.LABEL"></label> <input type="search" id="channelSearch" name="channelSearch" placeholder="{{ \'FILTERS.SEARCH.PLACEHOLDER\' | translate}}" data-ng-keydown="$ctrl.preventSubmit($event)" data-ng-change="$ctrl.applyFilters()" data-ng-model="$ctrl.searchString"> <span class="ico-mglass"></span></div><div class="filter-groups pull-left" data-ng-if="$ctrl.characteristicsGroups" data-ng-repeat="group in $ctrl.characteristicsGroups"><h3>{{item.label}}</h3><div ng-if="group.canSelectMultipleItems"><h3>{{group.label}}</h3><v-group-checkbox data-oncheckboxchange="$ctrl.applyFilters()" data-name="characteristic[{{group.key}}][{{$index}}]" data-ng-model="$ctrl.selectedCharacteristics[group.key]" data-items="group.items"></v-group-checkbox></div><div ng-if="!group.canSelectMultipleItems"><h3>{{group.label}}</h3><v-radio-button data-onradiochange="$ctrl.applyFilters()" data-name="characteristic[{{group.key}}][{{$index}}]" data-ng-model="$ctrl.selectedCharacteristics[group.key]" items="group.items" required></v-radio-button></div></div><button type="button" class="btn-show-more" data-ng-click="$ctrl.showHideFilters()" data-ng-if="$ctrl.characteristicsGroups"><span data-ng-show="$ctrl.isFiltersVisible"><span data-translate="FILTERS.HIDE_FILTERS"></span>&nbsp;<span class="v-icon-arrow-up"></span></span> <span data-ng-hide="$ctrl.isFiltersVisible"><span data-translate="FILTERS.SHOW_FILTERS"></span>&nbsp;<span class="v-icon-arrow-down"></span></span></button></div>'
 */

angular.module('v-tv-package').component('vTvPackageFilters', {
    bindings: {
        showFilter: '@'
    },
    require: {
        channelsCtrl: '^vTvPackageChannels'
    },
    controller: function controller($scope, $translate, TvPackageChannelFiltersService, TvPackageChannelsHelperService) {
        var _this = this;

        var initFilters = function initFilters() {
            TvPackageChannelsHelperService.forEachMultiplex(_this.channelsCtrl.channelsList, function (mplex) {
                mplex.vm.isHiddenByFilters = false;
            });
        };

        this.selectedCharacteristics = {};
        this.isFiltersVisible = true;

        this.showHideFilters = function () {
            _this.isFiltersVisible = !_this.isFiltersVisible;
        };

        this.preventSubmit = function ($event) {
            if ($event.keyCode === 13) {
                $event.preventDefault();
            }
        };

        this.applyFilters = function () {
            var lowercasedSearchString = void 0;

            function escapeRegExp(str) {
                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
            }

            function isMultiplexHiddenByFilters(mplex, selectedCharGroup, selectedCharGroupKey) {
                if (angular.isArray(selectedCharGroup)) {
                    //is a multiple choice (checkbox)
                    for (var k = 0; k < selectedCharGroup.length; k++) {
                        var selectedChar = selectedCharGroup[k];

                        if (angular.isDefined(mplex.vm.characteristicsIndex[selectedCharGroupKey]) && mplex.vm.characteristicsIndex[selectedCharGroupKey].indexOf(selectedChar.id) !== -1) {
                            return false;
                        }
                    }
                } else if (mplex.vm.characteristicsIndex[selectedCharGroupKey].indexOf(selectedCharGroup.id) !== -1) {
                    //is a unique choice (radio)
                    return false;
                }

                return true;
            }

            function inMplexOrChannelsLabel(mplex, searchString) {
                var isMark = false;
                var regEx = new RegExp('(' + escapeRegExp(searchString) + ')', 'ig');

                mplex.vm.markedElems = {};
                mplex.vm.markedLabel = mplex.label;

                if (mplex.label.toLowerCase().indexOf(searchString) !== -1) {
                    isMark = true;
                    mplex.vm.markedLabel = mplex.label.replace(regEx, '<span class="search-match">$1</span>');
                }

                if (mplex.channels.length > 1) {
                    for (var i = 0; mplex.channels[i]; i++) {
                        if (mplex.channels[i].label.toLowerCase().indexOf(searchString) !== -1) {
                            isMark = true;
                            mplex.vm.markedElems[mplex.channels[i].id] = mplex.channels[i].label.replace(regEx, '<span class="search-match">$1</span>');
                        }
                    }
                }

                return isMark;
            }

            if (angular.isDefined(_this.channelsCtrl.channelsList)) {
                initFilters();

                if (angular.isDefined(_this.selectedCharacteristics)) {

                    angular.forEach(_this.selectedCharacteristics, function (selectedCharGroup, selectedCharGroupKey) {
                        var hasCriteriaInGroup = angular.isArray(selectedCharGroup) && selectedCharGroup.length || angular.isDefined(selectedCharGroup.id) && selectedCharGroup.id !== null;

                        if (hasCriteriaInGroup) {
                            TvPackageChannelsHelperService.forEachMultiplex(_this.channelsCtrl.channelsList, function (mplex) {
                                mplex.vm.isHiddenByFilters = mplex.vm.isHiddenByFilters || isMultiplexHiddenByFilters(mplex, selectedCharGroup, selectedCharGroupKey);
                            });
                        }
                    });
                }

                if (_this.searchString) {
                    lowercasedSearchString = _this.searchString.toLowerCase();

                    TvPackageChannelsHelperService.forEachMultiplex(_this.channelsCtrl.channelsList, function (mplex) {
                        mplex.vm.isHiddenByFilters = mplex.vm.isHiddenByFilters || !inMplexOrChannelsLabel(mplex, lowercasedSearchString);
                    });
                }
            }
        };

        TvPackageChannelFiltersService.getFilters().then(function (characteristicsGroups) {
            _this.characteristicsGroups = characteristicsGroups.characteristics;

            angular.forEach(characteristicsGroups.characteristics, function (group) {
                var emptyItem = void 0;

                if (!group.canSelectMultipleItems && !group.emptyAppend) {
                    group.emptyAppend = true;
                    emptyItem = {
                        label: $translate.instant('FILTERS.ALL'),
                        id: null
                    };
                    group.items.unshift(emptyItem);

                    _this.selectedCharacteristics[group.key] = emptyItem;
                }
            });

            _this.applyFilters();
        });

        this.$onInit = function () {
            $scope.$watchCollection('$ctrl.channelsCtrl.channelsList', _this.applyFilters);
        };
    },
    template:'<div class="filter-options row" ng-if="$ctrl.showFilter" ng-class="{\'collapsed\': !$ctrl.isFiltersVisible}"><div class="search-box"><label for="channelSearch" data-translate="FILTERS.SEARCH.LABEL"></label> <input type="search" id="channelSearch" name="channelSearch" placeholder="{{ \'FILTERS.SEARCH.PLACEHOLDER\' | translate}}" data-ng-keydown="$ctrl.preventSubmit($event)" data-ng-change="$ctrl.applyFilters()" data-ng-model="$ctrl.searchString"> <span class="ico-mglass"></span></div><div class="filter-groups pull-left" data-ng-if="$ctrl.characteristicsGroups" data-ng-repeat="group in $ctrl.characteristicsGroups"><h3>{{item.label}}</h3><div ng-if="group.canSelectMultipleItems"><h3>{{group.label}}</h3><v-group-checkbox data-oncheckboxchange="$ctrl.applyFilters()" data-name="characteristic[{{group.key}}][{{$index}}]" data-ng-model="$ctrl.selectedCharacteristics[group.key]" data-items="group.items"></v-group-checkbox></div><div ng-if="!group.canSelectMultipleItems"><h3>{{group.label}}</h3><v-radio-button data-onradiochange="$ctrl.applyFilters()" data-name="characteristic[{{group.key}}][{{$index}}]" data-ng-model="$ctrl.selectedCharacteristics[group.key]" items="group.items" required></v-radio-button></div></div><button type="button" class="btn-show-more" data-ng-click="$ctrl.showHideFilters()" data-ng-if="$ctrl.characteristicsGroups"><span data-ng-show="$ctrl.isFiltersVisible"><span data-translate="FILTERS.HIDE_FILTERS"></span>&nbsp;<span class="v-icon-arrow-up"></span></span> <span data-ng-hide="$ctrl.isFiltersVisible"><span data-translate="FILTERS.SHOW_FILTERS"></span>&nbsp;<span class="v-icon-arrow-down"></span></span></button></div>'
});